import React, { useState, useEffect } from "react";
import api from "../services/api";

export default function Proveedores() {
  const [proveedores, setProveedores] = useState([]);
  const [cargando, setCargando]       = useState(false);
  const [msg, setMsg]                 = useState(null);
  const [buscar, setBuscar]           = useState("");
  const [modalAbierto, setModalAbierto] = useState(false);
  const [editando, setEditando]       = useState(null);
  const [modalClasificacion, setModalClasificacion] = useState(null);
  const [motivoClasificacion, setMotivoClasificacion] = useState('');
  const [filtroCondicion, setFiltroCondicion] = useState('');
  const [form, setForm] = useState({
    nombre: "", rnc: "", telefono: "", email: "", direccion: "", contacto: "", tipo_persona: "juridica", condicion_fiscal: ""
  });

  const mostrarMsg = (texto, tipo = "success") => {
    setMsg({ texto, tipo });
    setTimeout(() => setMsg(null), 4000);
  };

  useEffect(() => { cargar(); }, []);

  const cargar = async () => {
    try {
      const res = await api.get("/ordenes-compra/proveedores");
      setProveedores(res.data);
    } catch (e) {
      mostrarMsg("Error al cargar proveedores", "error");
    }
  };

  const abrirNuevo = () => {
    setEditando(null);
    setForm({ nombre: "", rnc: "", telefono: "", email: "", direccion: "", contacto: "", tipo_persona: "juridica", condicion_fiscal: "" });
    setModalAbierto(true);
  };

  const abrirEditar = (p) => {
    setEditando(p);
    setForm({
      nombre: p.nombre,
      rnc: p.rnc || "",
      telefono: p.telefono || "",
      email: p.email || "",
      direccion: p.direccion || "",
      contacto: p.contacto || "",
      tipo_persona: p.tipo_persona || "juridica",
      condicion_fiscal: p.condicion_fiscal || "PENDIENTE_CLASIFICACION"
    });
    setModalAbierto(true);
  };

  const guardar = async () => {
    if (!form.nombre.trim()) return mostrarMsg("El nombre es obligatorio", "error");
    if (!editando && !form.condicion_fiscal) return mostrarMsg("Seleccione la condición fiscal", "error");
    setCargando(true);
    try {
      if (editando) {
        const ordinaryFields = Object.fromEntries(
          Object.entries(form).filter(([key]) => key !== 'condicion_fiscal')
        );
        await api.put(`/ordenes-compra/proveedores/${editando.id}`, ordinaryFields);
        mostrarMsg("✅ Proveedor actualizado");
      } else {
        await api.post("/ordenes-compra/proveedores", form);
        mostrarMsg("✅ Proveedor creado");
      }
      setModalAbierto(false);
      cargar();
    } catch (e) {
      mostrarMsg(e.response?.data?.error || "Error al guardar", "error");
    } finally {
      setCargando(false);
    }
  };

  const clasificar = async () => {
    if (!modalClasificacion || motivoClasificacion.trim().length < 15) {
      return mostrarMsg("El motivo debe contener al menos 15 caracteres", "error");
    }
    setCargando(true);
    try {
      await api.post(`/ordenes-compra/proveedores/${modalClasificacion.id}/corregir-dato-fiscal`, {
        campo: 'condicion_fiscal',
        valor_nuevo: modalClasificacion.nueva,
        motivo: motivoClasificacion,
      });
      setModalClasificacion(null);
      setMotivoClasificacion('');
      mostrarMsg("✅ Condición fiscal actualizada y auditada");
      cargar();
    } catch (e) {
      mostrarMsg(e.response?.data?.mensaje || "Error al clasificar proveedor", "error");
    } finally {
      setCargando(false);
    }
  };

  const toggleActivo = async (p) => {
    try {
      await api.put(`/ordenes-compra/proveedores/${p.id}`, { activo: !p.activo });
      mostrarMsg(`Proveedor ${!p.activo ? "activado" : "desactivado"}`);
      cargar();
    } catch (e) {
      mostrarMsg("Error al cambiar estado", "error");
    }
  };

  const filtrados = proveedores.filter(p => {
    const condicion = p.condicion_fiscal || 'PENDIENTE_CLASIFICACION';
    const needle = buscar.toLowerCase();
    return (!filtroCondicion || condicion === filtroCondicion) && (
      p.nombre.toLowerCase().includes(needle)
      || (p.rnc || "").includes(buscar)
      || (p.telefono || "").includes(buscar)
    );
  });

  return (
    <div style={s.container}>
      {msg && (
        <div style={{ ...s.msg, background: msg.tipo === "error" ? "#fee2e2" : "#d1fae5", color: msg.tipo === "error" ? "#991b1b" : "#065f46" }}>
          {msg.texto}
        </div>
      )}

      {/* HEADER */}
      <div style={s.header}>
        <div>
          <h1 style={s.titulo}>🏢 Proveedores</h1>
          <p style={s.subtitulo}>Gestión del catálogo de proveedores</p>
        </div>
        <button style={s.btnPrimary} onClick={abrirNuevo}>➕ Nuevo Proveedor</button>
      </div>

      {/* BUSCADOR */}
      <div style={s.card}>
        <input style={{ ...s.input, maxWidth: "350px" }}
          placeholder="🔍 Buscar por nombre, RNC o teléfono..."
          value={buscar} onChange={(e) => setBuscar(e.target.value)} />
        <select style={{ ...s.input, maxWidth: "230px", marginLeft: "12px" }} value={filtroCondicion} onChange={e => setFiltroCondicion(e.target.value)}>
          <option value="">Todas las condiciones</option>
          <option value="REGISTRADO">Registrado / Formal</option>
          <option value="NO_REGISTRADO">Informal / No registrado</option>
          <option value="PENDIENTE_CLASIFICACION">Pendientes de clasificar</option>
        </select>
        <span style={{ marginLeft: "12px", color: "#64748b", fontSize: "13px" }}>
          {filtrados.length} proveedor{filtrados.length !== 1 ? "es" : ""}
        </span>
      </div>

      {/* TABLA */}
      <div style={s.card}>
        {filtrados.length === 0 ? (
          <div style={s.vacio}>
            <div style={{ fontSize: "40px", marginBottom: "12px" }}>🏢</div>
            <p>No hay proveedores registrados</p>
            <button style={s.btnPrimary} onClick={abrirNuevo}>➕ Crear primer proveedor</button>
          </div>
        ) : (
          <table style={s.tabla}>
            <thead>
              <tr>
                {["#", "Nombre", "RNC", "Tipo de persona", "Condición fiscal", "Teléfono", "Email", "Contacto", "Estado", "Acciones"].map(h => (
                  <th key={h} style={s.th}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filtrados.map((p, i) => (
                <tr key={p.id} style={s.tr}>
                  <td style={s.td}>{i + 1}</td>
                  <td style={{ ...s.td, fontWeight: "700" }}>{p.nombre}</td>
                  <td style={s.td}>{p.rnc || "—"}</td>
                  <td style={s.td}>
                    <span style={{ ...s.badgeTipo, background: p.tipo_persona === "fisica" ? "#fef3c7" : "#dbeafe", color: p.tipo_persona === "fisica" ? "#92400e" : "#1e40af" }}>
                      {p.tipo_persona === "fisica" ? "Persona física" : "Persona jurídica"}
                    </span>
                  </td>
                  <td style={s.td}>
                    <span style={{ ...s.badgeTipo, background: (p.condicion_fiscal || 'PENDIENTE_CLASIFICACION') === 'PENDIENTE_CLASIFICACION' ? '#fef3c7' : (p.condicion_fiscal === 'NO_REGISTRADO' ? '#ede9fe' : '#d1fae5'), color: '#334155' }}>
                      {p.condicion_fiscal === 'REGISTRADO' ? 'Registrado / Formal' : p.condicion_fiscal === 'NO_REGISTRADO' ? 'Informal / No registrado' : 'Pendiente de clasificar'}
                    </span>
                  </td>
                  <td style={s.td}>{p.telefono || "—"}</td>
                  <td style={s.td}>{p.email || "—"}</td>
                  <td style={s.td}>{p.contacto || "—"}</td>
                  <td style={s.td}>
                    <span style={{
                      padding: "3px 10px", borderRadius: "20px", fontSize: "12px", fontWeight: "700",
                      background: p.activo ? "#d1fae5" : "#fee2e2",
                      color: p.activo ? "#065f46" : "#991b1b"
                    }}>
                      {p.activo ? "✅ Activo" : "❌ Inactivo"}
                    </span>
                  </td>
                  <td style={s.td}>
                    <div style={{ display: "flex", gap: "6px" }}>
                      <button style={s.btnIcon} onClick={() => abrirEditar(p)} title="Editar">✏️</button>
                      <button style={s.btnIcon} onClick={() => { setModalClasificacion({ id: p.id, nombre: p.nombre, nueva: p.condicion_fiscal === 'NO_REGISTRADO' ? 'REGISTRADO' : 'NO_REGISTRADO' }); setMotivoClasificacion(''); }} title="Clasificar / cambiar condición fiscal">⚖️</button>
                      <button style={{ ...s.btnIcon, background: p.activo ? "#fee2e2" : "#d1fae5" }}
                        onClick={() => toggleActivo(p)} title={p.activo ? "Desactivar" : "Activar"}>
                        {p.activo ? "🔴" : "🟢"}
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {/* MODAL */}
      {modalAbierto && (
        <div style={s.overlay} onClick={() => setModalAbierto(false)}>
          <div style={s.modal} onClick={e => e.stopPropagation()}>
            <div style={s.modalHeader}>
              <h2 style={{ margin: 0, fontSize: "18px", fontWeight: "700" }}>
                {editando ? "✏️ Editar Proveedor" : "➕ Nuevo Proveedor"}
              </h2>
              <button style={s.btnCerrar} onClick={() => setModalAbierto(false)}>✕</button>
            </div>

            <div style={s.grid2}>
              <div style={s.formGroup}>
                <label style={s.label}>Nombre *</label>
                <input style={s.input} placeholder="Nombre del proveedor"
                  value={form.nombre} onChange={e => setForm({ ...form, nombre: e.target.value })} />
              </div>
              <div style={s.formGroup}>
                <label style={s.label}>RNC</label>
                <input style={s.input} placeholder="000-00000-0"
                  value={form.rnc} onChange={e => setForm({ ...form, rnc: e.target.value })} />
              </div>
              <div style={s.formGroup}>
                <label style={s.label}>Tipo de persona</label>
                <select style={s.input}
                  value={form.tipo_persona}
                  onChange={e => setForm({ ...form, tipo_persona: e.target.value })}>
                  <option value="juridica">Persona jurídica</option>
                  <option value="fisica">Persona física</option>
                </select>
              </div>
              <div style={s.formGroup}>
                <label style={s.label}>Condición fiscal *</label>
                {editando ? (
                  <>
                    <div style={{ ...s.input, background: '#f8fafc', color: '#475569' }}>
                      {form.condicion_fiscal === 'REGISTRADO' ? 'Registrado / Formal' : form.condicion_fiscal === 'NO_REGISTRADO' ? 'Informal / No registrado' : 'Pendiente de clasificar'}
                    </div>
                    <button type="button" style={{ ...s.btnSecondary, padding: '7px 10px', fontSize: '12px' }} onClick={() => { setModalClasificacion({ id: editando.id, nombre: editando.nombre, nueva: form.condicion_fiscal === 'NO_REGISTRADO' ? 'REGISTRADO' : 'NO_REGISTRADO' }); setMotivoClasificacion(''); }}>Clasificar / cambiar condición fiscal</button>
                  </>
                ) : (
                  <select style={s.input} value={form.condicion_fiscal} onChange={e => setForm({ ...form, condicion_fiscal: e.target.value })}>
                    <option value="">Seleccione una condición</option>
                    <option value="REGISTRADO">Registrado / Formal</option>
                    <option value="NO_REGISTRADO">Informal / No registrado</option>
                  </select>
                )}
              </div>
              <div style={s.formGroup}>
                <label style={s.label}>Teléfono</label>
                <input style={s.input} placeholder="809-000-0000"
                  value={form.telefono} onChange={e => setForm({ ...form, telefono: e.target.value })} />
              </div>
              <div style={s.formGroup}>
                <label style={s.label}>Email</label>
                <input style={s.input} placeholder="correo@empresa.com" type="email"
                  value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} />
              </div>
              <div style={s.formGroup}>
                <label style={s.label}>Persona de contacto</label>
                <input style={s.input} placeholder="Nombre del contacto"
                  value={form.contacto} onChange={e => setForm({ ...form, contacto: e.target.value })} />
              </div>
              <div style={s.formGroup}>
                <label style={s.label}>Dirección</label>
                <input style={s.input} placeholder="Dirección física"
                  value={form.direccion} onChange={e => setForm({ ...form, direccion: e.target.value })} />
              </div>
            </div>

            <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px", marginTop: "20px" }}>
              <button style={s.btnSecondary} onClick={() => setModalAbierto(false)}>Cancelar</button>
              <button style={s.btnPrimary} onClick={guardar} disabled={cargando}>
                {cargando ? "Guardando..." : "💾 Guardar"}
              </button>
            </div>
          </div>
        </div>
      )}
      {modalClasificacion && (
        <div style={s.overlay} onClick={() => setModalClasificacion(null)}>
          <div style={s.modal} onClick={e => e.stopPropagation()}>
            <div style={s.modalHeader}>
              <h2 style={{ margin: 0, fontSize: "18px", fontWeight: "700" }}>⚖️ Clasificar proveedor</h2>
              <button style={s.btnCerrar} onClick={() => setModalClasificacion(null)}>✕</button>
            </div>
            <p style={{ color: '#475569' }}>Proveedor: <strong>{modalClasificacion.nombre}</strong></p>
            <div style={s.formGroup}>
              <label style={s.label}>Nueva condición fiscal</label>
              <select style={s.input} value={modalClasificacion.nueva} onChange={e => setModalClasificacion({ ...modalClasificacion, nueva: e.target.value })}>
                <option value="REGISTRADO">Registrado / Formal</option>
                <option value="NO_REGISTRADO">Informal / No registrado</option>
              </select>
            </div>
            <div style={{ ...s.formGroup, marginTop: 12 }}>
              <label style={s.label}>Motivo de auditoría *</label>
              <textarea style={{ ...s.input, minHeight: 90 }} value={motivoClasificacion} onChange={e => setMotivoClasificacion(e.target.value)} placeholder="Explique la clasificación (mínimo 15 caracteres)" />
            </div>
            <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px", marginTop: "20px" }}>
              <button style={s.btnSecondary} onClick={() => setModalClasificacion(null)}>Cancelar</button>
              <button style={s.btnPrimary} onClick={clasificar} disabled={cargando}>{cargando ? 'Guardando...' : 'Guardar clasificación'}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const s = {
  container:   { padding: "24px", maxWidth: "100%", margin: "0 auto", fontFamily: "'Segoe UI', sans-serif" },
  header:      { display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "20px", flexWrap: "wrap", gap: "12px" },
  titulo:      { margin: 0, fontSize: "26px", fontWeight: "800", color: "#0f172a" },
  subtitulo:   { margin: "4px 0 0", color: "#64748b", fontSize: "14px" },
  msg:         { padding: "12px 16px", borderRadius: "8px", marginBottom: "16px", fontWeight: "600", fontSize: "14px" },
  card:        { background: "white", borderRadius: "16px", padding: "20px", boxShadow: "0 1px 3px rgba(0,0,0,.1)", marginBottom: "16px" },
  input:       { padding: "9px 12px", border: "1px solid #e2e8f0", borderRadius: "8px", fontSize: "14px", outline: "none", width: "100%", boxSizing: "border-box" },
  tabla:       { width: "100%", borderCollapse: "collapse" },
  th:          { padding: "10px 12px", textAlign: "left", fontSize: "12px", fontWeight: "700", color: "#64748b", background: "#f8fafc", borderBottom: "2px solid #e2e8f0" },
  td:          { padding: "11px 12px", fontSize: "14px", color: "#1e293b", borderBottom: "1px solid #f1f5f9" },
  tr:          { transition: "background .15s" },
  btnPrimary:  { padding: "10px 20px", background: "#1e40af", color: "white", border: "none", borderRadius: "8px", fontWeight: "700", cursor: "pointer", fontSize: "14px" },
  btnSecondary:{ padding: "10px 20px", background: "#f1f5f9", color: "#334155", border: "none", borderRadius: "8px", fontWeight: "700", cursor: "pointer", fontSize: "14px" },
  btnIcon:     { padding: "6px 10px", background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: "6px", cursor: "pointer", fontSize: "14px" },
  badgeTipo:   { padding: "3px 10px", borderRadius: "20px", fontSize: "12px", fontWeight: "700", whiteSpace: "nowrap" },
  vacio:       { textAlign: "center", padding: "40px", color: "#94a3b8" },
  grid2:       { display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px" },
  formGroup:   { display: "flex", flexDirection: "column", gap: "6px" },
  label:       { fontSize: "13px", fontWeight: "600", color: "#374151" },
  overlay:     { position: "fixed", inset: 0, background: "rgba(0,0,0,.5)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000 },
  modal:       { background: "white", borderRadius: "16px", padding: "24px", width: "100%", maxWidth: "560px", maxHeight: "90vh", overflowY: "auto" },
  modalHeader: { display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" },
  btnCerrar:   { background: "none", border: "none", fontSize: "18px", cursor: "pointer", color: "#64748b" },
};
